<template>
	<v-tabs
		class="round-card"
		height="34"
		background-color="background-1"
		slider-color="primary">
		<v-tab key="Campi" ripple class="secondary-tab">
			Campi
		</v-tab>
		<v-tab key="Azioni" ripple class="secondary-tab">
			Azioni
		</v-tab>
		<v-tab key="Categorie" ripple class="secondary-tab">
			Categorie
		</v-tab>
		<v-tab key="Altro" ripple class="secondary-tab">
			Altro
		</v-tab>

		<v-tab-item class="pb-offset background-1 pt-3" key="Campi">

			<v-row class="ma-0 pb-offset">

				<v-col class="pa-0 pt-2" cols="12">
					<fields-selector
						model-def="companycontact"
					></fields-selector>
				</v-col>

			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Azioni">
			<v-row class="ma-0 pb-offset">

				<v-col class="pa-0 pt-2" cols="12">
					<actions-selector model-def="companycontact"></actions-selector>
				</v-col>

			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Categorie">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0" cols="12">
                    <crud
                        title="Tipo contatti"
                        action-icon='settings'
                        model-def='generaltypes-contact_type'
                        action-position='absolute'
                        crudDialog
                    ></crud>
                </v-col>
            </v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Altro">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0 pt-2" cols="12">
					<company-contacts-options></company-contacts-options>
				</v-col>
			</v-row>
		</v-tab-item>
	</v-tabs>
</template>
<script>

    import FieldsSelector from '@/components/common/FieldsSelector'
    import ActionsSelector from '@/components/common/ActionsSelector'
	import CompanyContactsOptions from '@/components/modules/crm/settings/CompanyContactsOptions'

	export default {
		name:'setting-companies',
        components: {
            FieldsSelector,
            ActionsSelector,
            CompanyContactsOptions,
        },
	}
  </script>
